export default __webpack_public_path__ + "static/media/wallet_icon.a7c67bd6.svg";